import React from 'react'
import { withStyles, Divider as DividerUI } from '@material-ui/core';
import PropTypes from 'prop-types';
import Title from 'components/Title';
import clsx from "clsx";

const style = theme => ({
	title: {
		marginTop: theme.spacing(2),
	},
	divider: {
		marginBottom: theme.spacing(2),
	}
})

function Divider({
	classes,
	titleClassName,
	children,
	variant
}) {
	return (
		<>
			<Title className={clsx(classes.title, titleClassName)} variant={variant}>
				{children}
			</Title>
			<DividerUI className={classes.divider} />
		</>
	)
}

Divider.propTypes = {
	classes: PropTypes.any,
}

Divider.defaultProps = {
}

export default withStyles(style)(Divider);